"use client";

import { useState, useEffect } from "react";
import { useLanguage } from "../../hooks/useLanguage";
import config from "../../config/config";
import HeroSlider from "./HeroSlider";

export default function HeroSection() {
  const [heroSliders, setHeroSliders] = useState([]);
  const [loading, setLoading] = useState(true);
  const { language } = useLanguage();

  // Fetch hero settings from API
  useEffect(() => {
    const fetchHeroSettings = async () => {
      try {
        const response = await fetch(`${config.NEXT_PUBLIC_API_URL}/api/public/settings/homepage/hero`);
        const data = await response.json();
        if (data.success && data.data && data.data.sliders) {
          setHeroSliders(data.data.sliders.filter(s => s.isActive !== false));
        }
      } catch (error) {
        console.error('Error fetching hero settings:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchHeroSettings();
  }, [language]);

  

  if (!heroSliders) {
    return null;
  }
  if (heroSliders.length === 0) {
    return null;
  }

  return (
    <section className="w-full">
      <HeroSlider sliders={heroSliders} />
    </section>
  );
}